import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import { useFormattingContext } from '../../../FormattingProvider/FormattingContext'
import { useFirmReportData } from '../../../../../api/coreData'
import { useDenaliFilter } from '../../filters/DenaliFilterContextProvider'
import BasicLineChart from '../../../../charts/echarts/Line'

const useFormatters = (valueFormat, categoryFormat) => {
  const { formatter } = useFormattingContext()

  const valueFormatter = useCallback(d => formatter(d, valueFormat), [formatter, valueFormat])
  const categoryFormatter = useCallback(d => formatter(d, categoryFormat), [formatter, categoryFormat])

  return {
    valueFormatter,
    categoryFormatter
  }
}

function DenaliBasicLine ({
  reportId,
  baseQuery,
  width,
  height,
  xAccessor,
  yAccessor,
  valueFormat,
  categoryFormat,
  chartProps
}) {
  const { filter, membershipFilter } = useDenaliFilter()
  const query = useMemo(() => {
    return {
      ...baseQuery,
      membershipFilter,
      filters: {
        ...(filter || {}),
        ...(baseQuery?.filters || {})
      },
      reportId
    }
  }, [reportId, baseQuery, filter, membershipFilter])

  const { valueFormatter, categoryFormatter } = useFormatters(valueFormat, categoryFormat)
  const { data: report, isLoading } = useFirmReportData(query)
  const chartData = useMemo(() => {
    const series = (report?.data || []).map(item => ({
      x: get(item, xAccessor),
      y: get(item, yAccessor)
    }))

    return {
      series
    }
  }, [report, xAccessor, yAccessor])

  if (isLoading) return null

  return (
    <BasicLineChart
      theme={{
        fontFamily: 'var(--root-font) !important',
        fontSize: '12px'
      }}
      height={height}
      width={width}
      data={chartData}
      valueFormat={valueFormatter}
      categoryFormat={categoryFormatter}
      chartProps={chartProps}
    />
  )
}

DenaliBasicLine.propTypes = {
  reportId: PropTypes.string,
  baseQuery: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  xAccessor: PropTypes.string,
  yAccessor: PropTypes.string,
  valueFormat: PropTypes.string,
  categoryFormat: PropTypes.string,
  chartProps: PropTypes.object
}

DenaliBasicLine.defaultProps = {
  valueFormat: 'marketValue',
  categoryFormat: 'date',
  height: 300
}

export default DenaliBasicLine
